import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/Components/ui/select"
import { SORT_OPTIONS } from "./listingSort"

/**
 * Compact "Sort by" select rendered in a listing section header. Selecting an
 * option asks the parent grid to reload the list from the server in the chosen
 * order (Meilisearch handles the ordering).
 */
export default function ListingSortControl({ variant, value, onChange }) {
    const options = SORT_OPTIONS[variant] ?? []

    if (options.length === 0) {
        return null
    }

    return (
        <div className="flex items-center gap-2 whitespace-nowrap">
            <span className="hidden text-sm text-gray-600 sm:inline">
                Sort by
            </span>
            <Select value={value} onValueChange={onChange}>
                <SelectTrigger className="h-9 w-full md:w-[200px] text-sm">
                    <SelectValue placeholder="Sort by" />
                </SelectTrigger>
                <SelectContent className={"bg-white"}>
                    {options.map((option) => (
                        <SelectItem key={option.value} value={option.value}>
                            {option.label}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    )
}
